/* metro-ui-components@9.20.0 */
"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
/* eslint-disable */
var React = require("react");
var IconSVG = /** @class */ (function (_super) {
    tslib_1.__extends(IconSVG, _super);
    function IconSVG() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    IconSVG.prototype.render = function () {
        return (React.createElement("svg", tslib_1.__assign({ role: "img", viewBox: "0 0 16 16" }, this.props),
            React.createElement("path", { d: "m11.4756 12.0348h-3.057-.68-3.057v-.34c0-.375.294-.764.653-.868l1.725-.494v-.947l-.001-.003c-.609-.386-1.018-1.106-1.018-1.93 0-1.23.912-2.228 2.038-2.228s2.039.998 2.039 2.228c0 .826-.412 1.546-1.022 1.931l.002.002v.947l1.725.494c.359.104.653.493.653.868zm3.797-8.706h-9.153l-1.242-1.133c-.136-.126-.321-.196-.514-.196h-3.636c-.402 0-.728.298-.728.664v10.63c0 .368.326.665.728.665h14.545c.402 0 .727-.297.727-.665v-9.301c0-.366-.325-.664-.727-.664z" })));
    };
    return IconSVG;
}(React.Component));
exports.IconSVG = IconSVG;